import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useUser } from "@/shared/lib/hooks/useUser/useUser";
import { useIsAdmin } from "@/shared/config/admin";
import { getRouteAdminClubLeague } from "@/shared/config/router";

/*
 * «Лига клубов» на torsunov.com — только администраторам (IMPL_LEAGUE §7.6).
 *
 * Маршрут admin/club-league/* стоит с authOnly: не вошедший уходит на вход и возвращается сюда (так админ
 * приходит по переключателю «Россия | За рубежом» с torsunov.life). Дальше решает этот гейт:
 *   вошёл, не администратор → голое «404», как у адреса без страницы; ни одного запроса лиги;
 *   администратор           → раздел (useIsAdmin: «смотреть как пользователь» админа не запирает).
 * Пока грузится список администраторов — пусто. Второй замок — require_admin на site_server (403 → текст).
 */

/** Ровно то, что рисует NOT_FOUND в routeConfig. */
const NotFound = () => <div>404</div>;

export const ClubLeagueAdminGate = ({ children }: { children: React.ReactNode }) => {
    const { user } = useUser();
    const email = user && typeof user !== "string" ? (user as { email?: string }).email || "" : "";
    const { isAdmin, loading } = useIsAdmin(email);
    if (!email) return <NotFound />;
    if (!isAdmin && loading) return <div data-testid="club-league-checking" />;
    if (!isAdmin) return <NotFound />;
    return <>{children}</>;
};

/**
 * Старая клубная консоль /:lang/admin-marathons ведёт в новый раздел, на вкладку «Марафоны»
 * (IMPL_LEAGUE §0.5 п. 5). Закладки и ссылки пульта марафонов лиги продолжают работать.
 */
export const ToClubLeagueMarathons = () => {
    const { lang } = useParams<{ lang?: string }>();
    return <Navigate to={getRouteAdminClubLeague(lang || "ru", "marathons")} replace />;
};
